import { IUser } from "../../types/interfaces/user.interface";
import { MedallionType, OwnershipType } from "../../types/main";
import { ScenarioData } from "../reducers/checkout";

export type Action = { type: string; payload: any };

export const hideFooter = (hide: boolean): Action => ({
  type: "HIDE_FOOTER",
  payload: hide,
});

export const userLoggedIn = (user: IUser): Action => ({
  type: "LOGGED_IN",
  payload: user,
});

export const userLoggedOut = (): Action => ({
  type: "USER_LOGGED_OUT",
  payload: true,
});

export const isHomeHeader = (showHeader: boolean): Action => ({
  type: "IS_HOME_HEADER",
  payload: showHeader,
});

export const setOwnerShipType = (type: OwnershipType): Action => ({
  type: "SET_OWNER_SHIP_TYPE",
  payload: type,
});

export const setMedailionType = (type: MedallionType): Action => ({
  type: "SET_MEDALLION_TYPE",
  payload: type,
});

export const readyForSecondStepCheckout = (ready: boolean): Action => ({
  type: "READY_FOR_SECOND_STEP_CHECKOT",
  payload: ready,
});

export const readyForSThirdStepCheckout = (ready: boolean): Action => ({
  type: "READY_FOR_THIRD_STEP_CHECKOT",
  payload: ready,
});

export const setStoreMedallions = (medallions: any): Action => ({
  type: "SET_MEDALLIONS",
  payload: medallions,
});

export const setTransactionMode = (transactionUUid: any) => ({
  type: "SET_TRANSACTION_MODE",
  payload: transactionUUid,
});

export const setTransactionsTypes = (details: any) => ({
  type: "SET_TRANSACTION_TYPES",
  payload: details,
});

/**
 * Set scenario data from the questionnaire.
 * Called when a scenario is identified and user proceeds.
 */
export const setScenarioData = (data: ScenarioData): Action => ({
  type: "SET_SCENARIO_DATA",
  payload: data,
});

/**
 * Clear scenario data from Redux state.
 * Called when starting a new transaction or resetting.
 */
export const clearScenarioData = (): Action => ({
  type: "CLEAR_SCENARIO_DATA",
  payload: null,
});
